<div class="epd">
  <!-- ─── Avatar with pencil ─────────────────────────────────────── -->
  <div class="epd-avatar-block">
    <div class="epd-avatar-wrap">
      <img *ngIf="currentPhoto" class="epd-avatar" [src]="currentPhoto" alt="Profile photo" />
      <div *ngIf="!currentPhoto" class="epd-avatar epd-avatar-initials">{{ initials }}</div>

      <button type="button" class="epd-avatar-edit" (click)="openPhotoPicker()" aria-label="Change photo"
        pTooltip="Change photo" tooltipPosition="bottom">
        <i class="pi pi-pencil"></i>
      </button>
      <input #fileInput type="file" accept="image/*" class="epd-file-input" (change)="onPhotoSelected($event)" />
    </div>
    <p class="epd-avatar-hint">Click the pencil to update your photo</p>
  </div>

  <!-- ─── Form ───────────────────────────────────────────────────── -->
  <form [formGroup]="form" class="epd-grid">
    <div class="epd-field">
      <label>First Name <span class="req">*</span></label>
      <input pInputText formControlName="firstName" placeholder="Enter first name"
        [class.ng-invalid]="isInvalid('firstName')" [class.ng-dirty]="isInvalid('firstName')" />
      <small class="epd-err" *ngIf="isInvalid('firstName')">First name is required</small>
    </div>

    <div class="epd-field">
      <label>Last Name</label>
      <input pInputText formControlName="lastName" placeholder="Enter last name" />
    </div>

    <div class="epd-field">
      <label>Gender <span class="req">*</span></label>
      <p-dropdown formControlName="gender" [options]="genders" optionLabel="name" optionValue="value"
        placeholder="Select gender" appendTo="body" [style]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('gender')" [class.ng-dirty]="isInvalid('gender')"></p-dropdown>
      <small class="epd-err" *ngIf="isInvalid('gender')">Gender is required</small>
    </div>

    <div class="epd-field">
      <label>Date of Birth <span class="req">*</span></label>
      <p-calendar formControlName="dateOfBirth" [showIcon]="true" icon="pi pi-calendar" appendTo="body"
        dateFormat="dd/mm/yy" placeholder="DD/MM/YYYY" [maxDate]="maxDob" [style]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('dateOfBirth')" [class.ng-dirty]="isInvalid('dateOfBirth')"></p-calendar>
      <small class="epd-err" *ngIf="isInvalid('dateOfBirth')">Date of birth is required</small>
    </div>

    <div class="epd-field epd-span-2">
      <label>Current Location <span class="req">*</span></label>
      <p-autoComplete formControlName="location" [suggestions]="suggestions" (completeMethod)="searchLocation($event)"
        field="description" [minLength]="3" placeholder="Search your location..." appendTo="body"
        (onSelect)="onLocationSelect($event)" [style]="{ width: '100%' }" [inputStyle]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('location')" [class.ng-dirty]="isInvalid('location')">
        <ng-template let-prediction pTemplate="item">
          <div class="white-space-normal" style="word-wrap: break-word;">{{ prediction.description }}</div>
        </ng-template>
      </p-autoComplete>
      <small class="epd-err" *ngIf="isInvalid('location')">Location is required</small>
    </div>

    <div class="epd-field">
      <label>Intended Countries <span class="req">*</span></label>
      <p-multiSelect formControlName="intendedCountries" [options]="countries" optionLabel="label" optionValue="value"
        placeholder="Select countries" appendTo="body" [style]="{ width: '100%' }" styleClass="epd-multiselect"
        [class.ng-invalid]="isInvalid('intendedCountries')" [class.ng-dirty]="isInvalid('intendedCountries')">
        <ng-template let-option pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img [src]="option.icon" alt="" width="20" height="20" />
            <span>{{ option.label }}</span>
          </div>
        </ng-template>
      </p-multiSelect>
      <small class="epd-err" *ngIf="isInvalid('intendedCountries')">Select at least one country</small>
    </div>

    <div class="epd-field">
      <label>Intended Level <span class="req">*</span></label>
      <p-dropdown formControlName="intendedLevel" [options]="courseLevels" optionLabel="name" optionValue="key"
        placeholder="Select level" appendTo="body" [style]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('intendedLevel')" [class.ng-dirty]="isInvalid('intendedLevel')"></p-dropdown>
      <small class="epd-err" *ngIf="isInvalid('intendedLevel')">Intended level is required</small>
    </div>

    <div class="epd-field">
      <label>When do you plan on starting college? <span class="req">*</span></label>
      <p-dropdown formControlName="collegeStartTiming" [options]="collegeStartTimings" optionLabel="name" optionValue="key"
        placeholder="Select" appendTo="body" [style]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('collegeStartTiming')" [class.ng-dirty]="isInvalid('collegeStartTiming')"></p-dropdown>
      <small class="epd-err" *ngIf="isInvalid('collegeStartTiming')">Start time is required</small>
    </div>

    <div class="epd-field">
      <label>Choose where you are in your journey? <span class="req">*</span></label>
      <p-dropdown formControlName="journeyStatus" [options]="journeyStatuses" optionLabel="name" optionValue="key"
        placeholder="Select" appendTo="body" [style]="{ width: '100%' }"
        [class.ng-invalid]="isInvalid('journeyStatus')" [class.ng-dirty]="isInvalid('journeyStatus')">
        <ng-template let-j pTemplate="item">
          <div class="flex align-items-center gap-2">
            <img [src]="j.icon" alt="" width="20" height="20" />
            <span>{{ j.name }}</span>
          </div>
        </ng-template>
      </p-dropdown>
      <small class="epd-err" *ngIf="isInvalid('journeyStatus')">Journey status is required</small>
    </div>
  </form>

  <!-- ─── Footer ─────────────────────────────────────────────────── -->
  <div class="epd-footer">
    <button type="button" class="epd-btn epd-btn-ghost" (click)="reset()">Reset</button>
    <button type="button" class="epd-btn epd-btn-primary" [disabled]="loading" (click)="submit()">
      <i *ngIf="loading" class="pi pi-spin pi-spinner"></i>
      Update Information
    </button>
  </div>
</div>

<!-- ─── Cropper dialog ───────────────────────────────────────────── -->
<p-dialog [visible]="!!croppingImageUrl" [modal]="true" header="Crop Photo" [draggable]="false" [resizable]="false"
  [style]="{ width: '520px', 'max-width': '92vw' }" appendTo="body" (onHide)="cancelCrop()">
  <div class="epd-cropper">
    <img #imageToCrop [src]="croppingImageUrl" alt="Crop preview" style="max-width: 100%; display: block;" />
  </div>
  <ng-template pTemplate="footer">
    <button type="button" class="epd-btn epd-btn-ghost" (click)="cancelCrop()">Cancel</button>
    <button type="button" class="epd-btn epd-btn-primary" [disabled]="uploadingPhoto" (click)="cropAndUpload()">
      <i *ngIf="uploadingPhoto" class="pi pi-spin pi-spinner"></i>
      Crop &amp; Upload
    </button>
  </ng-template>
</p-dialog>

<p-toast></p-toast>
